export default function BlogEndLine() {
  return (
    <div className="border-b-[1.5px] border-black w-full h-px col-span-full pt-16 md:pt-28 " />
  );
}
